import cn from 'classnames'
import { Link, useNavigate } from 'react-router-dom'
import { IoMdCheckboxOutline } from 'react-icons/io'
import { BoardCardTasks } from 'components/common/BoardCardTasks'
import { Users } from './Users'
import { DateInfo } from './DateInfo'
import s from './ProposalCard.scss'
import { preventDefault, getNoBidClientStyle } from 'utils/helpers'

const ProposalCard = ({
  id,
  name,
  status,
  company,
  users = [],
  todayTasks = [],
  lateTasks = [],
  futureTasks = [],
  completedTasks = [],
  dueDate,
  followUpDate,
  showTasksModal,
  isAwardedToCompany,
  laneId,
  index
}) => {
  const navigate = useNavigate()
  const navigateTo = (e, url) => {
    preventDefault(e)
    navigate(url)
  }
  const checkMarkClass = lateTasks.length
    ? 'late'
    : todayTasks.length
      ? 'today'
      : futureTasks.length
        ? 'future'
        : completedTasks.length
          ? 'completed'
          : 'noTasks'
  return (
    <Link className={s.link} to={`/proposals/${id}`}>
      <div
        data-cy={`card-${laneId}-${index}`}
        className={cn(s.card, {
          [s.late]: checkMarkClass === 'late'
        })}
      >
        <DateInfo id={id} status={status} followUpDate={followUpDate} dueDate={dueDate} />
        <IoMdCheckboxOutline
          onClick={e => showTasksModal(e, id, status, name)}
          className={cn(s.pullRight, s.checkMark, s[checkMarkClass])}
        />
        <div className={s.clearfix} />
        <div className={s.name}>{name}</div>
        <div>
          <span
            className={s.clientLink}
            onClick={e => navigateTo(e, `/companies/${company.id}`)}
            style={getNoBidClientStyle(company.noBid)}
          >
            {company.name}
          </span>
        </div>
        <div className={s.footer}>
          <BoardCardTasks
            todayTasks={todayTasks}
            lateTasks={lateTasks}
            futureTasks={futureTasks}
            completedTasks={completedTasks}
          />
          <Users users={users} />
          <div className={s.clearfix} />
          <div className={s.awardedContainer}>
            Contractor Awarded: {isAwardedToCompany ? 'YES' : 'NO'}
          </div>
        </div>
      </div>
    </Link>
  )
}

export default ProposalCard
